import { render, staticRenderFns } from "./ProductDescriptionPopupIframe.vue?vue&type=template&id=6d949c90&"
import script from "./ProductDescriptionPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductDescriptionPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports